import { buildApiUrl } from '@/app/lib/api-config';
import type { PipelineStepId } from '~/app/components/pipeline-debug/PipelineDebug/types';
import {
  readNdjsonStream,
  type PipelineStreamCallbacks,
} from './ndjson-stream';

export type { PipelineStreamCallbacks };

export const PipelineDebugService = {
  async runStepStream(
    stepId: PipelineStepId,
    organizationId: string,
    assetId: string,
    input: unknown,
    callbacks: PipelineStreamCallbacks,
    signal?: AbortSignal,
  ): Promise<unknown> {
    const response = await fetch(
      buildApiUrl(`/api/v1/admin/pipeline-debug/steps/${stepId}/run-stream`),
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          organizationId,
          assetId,
          input,
        }),
        signal,
      },
    );

    if (!response.ok) {
      const errorPayload = (await response.json().catch(() => null)) as {
        message?: string | string[];
      } | null;
      const message = Array.isArray(errorPayload?.message)
        ? errorPayload.message.join('; ')
        : errorPayload?.message;

      throw new Error(message || 'Pipeline step failed');
    }

    if (!response.body) {
      throw new Error('Streaming is not supported in this browser.');
    }

    return readNdjsonStream(response.body, callbacks);
  },
};
